(() => {
  const sel = (s, r = document) => r.querySelector(s);
  const selAll = (s, r = document) => [...r.querySelectorAll(s)];

  class CartDrawer {
    constructor() {
      this.drawer = sel("[data-cart-drawer]");
      this.overlay = sel("[data-cart-overlay]");
      if (!this.drawer || !this.overlay) return;
      this.hideSections = document.querySelectorAll(".sticky-wrapper , is-sticky , .--sticky-atc");
      this.sectionId = this.drawer.getAttribute("data-section-id");
      this.body = sel("[data-cart-body]", this.drawer);

      this.bindGlobalTriggers();
      this.bindInternalEvents();
    }

    bindGlobalTriggers() {
      // Open triggers anywhere (e.g., cart icon/button): add data-cart-open
      selAll("[data-cart-open]").forEach((btn) =>
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.open();
        })
      );

      // Close controls
      selAll("[data-cart-close]").forEach((btn) =>
        btn.addEventListener("click", () => this.close())
      );

      this.overlay.addEventListener("click", () => this.close());
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });
    }

    bindInternalEvents() {
      // Delegate inside drawer
      this.drawer.addEventListener("click", (e) => {
        const closeBtn = e.target.closest("[data-cart-close]");

        if (closeBtn) {
          e.preventDefault();
          this.close();
          return;
        }

        // Remove line
        const removeBtn = e.target.closest("[data-remove-line]");
        if (removeBtn) {
          const line = Number(removeBtn.getAttribute("data-remove-line"));
          this.updateLine(line, 0);
          return;
        }

        // Quantity minus/plus
        const minus = e.target.closest("[data-qty-minus]");
        const plus = e.target.closest("[data-qty-plus]");
        if (minus || plus) {
          const lineEl = e.target.closest(".cart-line");
          if (!lineEl) return;
          const line = Number(lineEl.getAttribute("data-line"));
          const input = sel("[data-qty-input]", lineEl);
          let qty = Number(input.value || 0);
          qty = minus ? Math.max(0, qty - 1) : qty + 1;
          this.updateLine(line, qty);
          return;
        }
      });

      // Direct input change
      this.drawer.addEventListener("change", (e) => {
        const input = e.target.closest("[data-qty-input]");
        if (input) {
          const lineEl = e.target.closest(".cart-line");
          const line = Number(lineEl.getAttribute("data-line"));
          const qty = Math.max(0, Number(input.value || 0));
          this.updateLine(line, qty);
        }
      });
    }

    open() {
      
      

        this.hideSections?.forEach((xsection) => {
          xsection.classList.add("hidden");
        });
      this.refresh().then(() => {
        this.drawer.removeAttribute("aria-hidden");
        this.overlay.hidden = false;
        document.documentElement.classList.add("cart-drawer-open");
        // Focus the close button for accessibility
        const closeBtn = sel("[data-cart-close]", this.drawer);
        closeBtn && closeBtn.focus();
      });
    }

    close() {
      

        this.hideSections?.forEach((xsection) => {
          xsection.classList.remove("hidden");
        });
      this.drawer.setAttribute("aria-hidden", "true");
      this.overlay.hidden = true;
      document.documentElement.classList.remove("cart-drawer-open");
    }

    async updateLine(line, quantity) {
      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ line, quantity }),
        });
        await this.refresh();
      } catch (e) {
        console.error("Cart update failed", e);
      }
    }

    async refresh() {
      setLoading("[data-cart-contents]", true);
      try {
        // Re-render section HTML and replace the contents inside [data-cart-contents]
        const url = `${window.location.pathname}?section_id=${this.sectionId}`;
        const html = await fetch(url, {
          headers: { Accept: "text/html" },
        }).then((r) => r.text());
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const newContents = temp.querySelector("[data-cart-contents]");
        const currentContents = sel("[data-cart-contents]", this.drawer);

        if (newContents && currentContents) {
          currentContents.replaceWith(newContents);
        }
        if (typeof window.giftProductModule === 'function') {
          window.giftProductModule();
        } 
      } finally {
        setLoading("[data-cart-contents]", false);
        window.updateCartitemCount();
      }
    }
  }

  // Init once DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    // new CartDrawer();
    window.cartDrawer = new CartDrawer();
  });
})();
window.setLoading = (selector, on = true) =>
  document
    .querySelectorAll(selector)
    .forEach((el) => el.classList.toggle("is-loading", on));


 window.updateCartitemCount = function () {
    // let item_count =   document.querySelector('.--cart-contents').dataset.cartItemCount;
    let item_count =  parseInt(document.querySelector('.--cart-contents').dataset.cartItemCount, 10) || 0;
    console.log("Cart Item count:", item_count);
    let countIcon = document.querySelector('.--cart-count');
    if (!countIcon) return;

    if (item_count > 0) {
      countIcon.textContent = item_count;
      countIcon.style.display = 'flex';
    } else {
      countIcon.textContent = '';
      countIcon.style.display = 'none';
    }
  };

  window.updateCartitemCount();



//   window.giftProductModule = async function () {
//   const giftCountEl = document.querySelector(".--gift-count-div");
//   if (!giftCountEl) return;

//   const threshold = parseInt(giftCountEl.dataset.giftProductThreshold, 10) || 0;
//   // const triggerId = parseInt(giftCountEl.dataset.freeGiftItemTriggerId, 10) || 0;
//   const giftId = parseInt(giftCountEl.dataset.giftProductId, 10) || 0;

//   if (threshold <= 0) return console.error('Invalid threshold');

//   try {
//     const cart = await fetch('/cart.js').then(res => res.json());
//     // const triggerItem = cart.items.find(item => item.id === triggerId);
//     // const triggerQty = triggerItem ? triggerItem.quantity : 0;
//     // const desired = Math.floor(triggerQty / threshold);
   
//     const desired = parseInt(giftCountEl.dataset.cart-item-without-gift, 10) > threshold ? 1 : 0;
//     const giftItem = cart.items.find(item => item.id === giftId);
//     const current = giftItem ? giftItem.quantity : 0;
//     console.log("triggerQty",triggerQty, "threshold", threshold);
//     console.log("Desired",desired, "Current", current);
//     if (current === desired) return console.log('Gift quantity correct');

//     const root = window.Shopify.routes.root;
//     let response;

//     if (desired === 0 || current > 0) {
//       response = await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ updates: { [giftId]: desired } })
//       });
//       if (!response.ok) throw new Error('Update failed');
//       console.log(desired > 0 ? 'Gift updated' : 'Gift removed', await response.json());
//     } else {
//       const formData = new FormData();
//       formData.append('id', giftId);
//       formData.append('quantity', desired.toString());
//       response = await fetch(`${root}cart/add.js`, {
//         method: 'POST',
//         body: formData,
//         headers: { 'X-Requested-With': 'XMLHttpRequest' }
//       });
//       if (!response.ok) throw new Error('Add failed');
//       console.log('Gift added', await response.json());
//     }

//     window.cartDrawer.refresh();
//   } catch (err) {
//     console.error('Error:', err);
//   }
// };

// window.giftProductModule = async function () {
//   const giftCountEl = document.querySelector(".--gift-count-div");
//   if (!giftCountEl) return;

//   const threshold = parseInt(giftCountEl.dataset.giftProductThreshold, 10) || 0;
//   const giftId = parseInt(giftCountEl.dataset.giftProductId, 10) || 0;

//   if (threshold <= 0) return console.error('Invalid threshold');

//   try {
//     const cart = await fetch('/cart.js').then(res => res.json());

//     const cartCount = parseInt(giftCountEl.dataset.cartItemWithoutGift, 10) || 0;
//     const desired = cartCount >= threshold ? 1 : 0;

//     const giftItem = cart.items.find(item => item.id === giftId);
//     const current = giftItem ? giftItem.quantity : 0;

//     console.log("CartCount", cartCount, "threshold", threshold);
//     console.log("Desired", desired, "Current", current);

//     if (current === desired) return console.log('Gift quantity correct');

//     const root = window.Shopify.routes.root;
//     let response;

//     if (desired === 0) {
//       response = await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ updates: { [giftId]: 0 } })
//       });
//     } else if (current > 0) {
//       response = await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ updates: { [giftId]: desired } })
//       });
//     } else {
//       const formData = new FormData();
//       formData.append('id', giftId);
//       formData.append('quantity', desired.toString());

//       response = await fetch(`${root}cart/add.js`, {
//         method: 'POST',
//         body: formData,
//         headers: { 'X-Requested-With': 'XMLHttpRequest' }
//       });
//     }

//     if (!response.ok) throw new Error('Cart operation failed');

//     console.log(await response.json());

//     if (window.cartDrawer?.refresh) {
//       window.cartDrawer.refresh();
//     }

//   } catch (err) {
//     console.error('Error:', err);
//   }
// };

/* Based on quantity */
// window.giftProductModule = async function () {
//   const giftCountEl = document.querySelector(".--gift-count-div");
//   if (!giftCountEl) return;

//   const threshold = parseInt(giftCountEl.dataset.giftProductThreshold, 10) || 0;
//   const cartItemWithoutGift = parseInt(giftCountEl.dataset.cartItemWithoutGift, 10) || 0;
//   const giftId = parseInt(giftCountEl.dataset.giftProductId, 10) || 0;
  
//   const desired = cartItemWithoutGift >= threshold ? 1 : 0;
//   console.log("threshold",threshold);
//   console.log("cartItemWithoutGift",cartItemWithoutGift);
//   console.log("giftId",giftId);

//   if (threshold <= 0) return console.error('Invalid threshold');

//   try {
//     const cart = await fetch('/cart.js').then(res => res.json());
   
    
//     const giftItem = cart.items.find(item => item.id === giftId);
//     const current = giftItem ? giftItem.quantity : 0;
   
//     console.log("Desired",desired, "Current", current);
//     if (current === desired) return console.log('Gift quantity correct');

//     const root = window.Shopify.routes.root;
//     let response;

//     if (desired === 0 || current > 0) {
//       response = await fetch(`/cart/update.js`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ updates: { [giftId]: desired } })
//       });
//       if (!response.ok) throw new Error('Update failed');
//       console.log(desired > 0 ? 'Gift updated' : 'Gift removed', await response.json());
//     } else {
      
//       const formData = new FormData();
//       formData.append('id', giftId);
//       formData.append('quantity', desired.toString());
//       response = await fetch(`/cart/add.js`, {
//         method: 'POST',
//         body: formData,
//         headers: { 'X-Requested-With': 'XMLHttpRequest' }
//       });
//       if (!response.ok) throw new Error('Add failed');
//       console.log('Gift added', await response.json());
     
//     }

//     window.cartDrawer.refresh();
//   } catch (err) {
//     console.error('Error:', err);
//   }
// };
/* Based on amount */
window.giftProductModule = async function () {
  const giftCountEl = document.querySelector(".--gift-count-div");
  if (!giftCountEl) return;

  const giftId = parseInt(giftCountEl.dataset.giftProductId, 10) || 0;
  const triggerAmount = parseInt(giftCountEl.dataset.cartDrawerBarAmount, 10) * Shopify.currency.rate * 100.0 || 0;

  console.log("Gift ID:", giftId);
  console.log("Trigger amount:", triggerAmount);

  if (triggerAmount <= 0) return console.error('Invalid trigger amount');

  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const giftItem = cart.items.find(item => item.id === giftId);
    const current = giftItem ? giftItem.quantity : 0;
    console.log("cart", cart)
    console.log("Cart Total:", cart.total_price);
    console.log("Current gift quantity:", current);

    // Set desired to 1 if cart total exceeds the trigger amount, else set to 0
    let desired = cart.total_price  > triggerAmount ? 1 : 0;
    console.log("Desired gift quantity:", desired);

    // Only update or remove gift if there is a change
    if (current !== desired) {
      let response;
      if (desired === 0 || current > 0) {
        // Remove gift if it's not needed
        response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: { [giftId]: 0 } })
        });
        if (!response.ok) throw new Error('Update failed');
        console.log('Gift removed', await response.json());
      } else {
        // Add gift if required
        const formData = new FormData();
        formData.append('id', giftId);
        formData.append('quantity', '1');
        response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Add failed');
        console.log('Gift added', await response.json());
      }

      // Refresh cart drawer to reflect changes
      console.log("Refresh Start");
      window.cartDrawer.refresh();
       console.log("Refresh End");
    } else {
      console.log('Gift quantity correct');
    }
  } catch (err) {
    console.error('Error:', err);
  }
};